import { Card, CardContent, CardActions, Button, Divider, Typography, Box, Switch, Chip, Tooltip, CircularProgress } from "@mui/material";

const HotelCard = ({ hotel, onView, onEdit, onDelete, onToggleActive, permissions, toggleLoading }) => {
  const isActive = hotel.isActive !== false;
  const isLoading = Boolean(toggleLoading && toggleLoading[hotel._id]);

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.2s ease-in-out",
        boxShadow: isActive ? 1 : 0,
        border: isActive ? "1px solid #e2e8f0" : "1px dashed #cbd5e1",
        backgroundColor: isActive ? "#ffffff" : "#f8fafc",
        opacity: isActive ? 1 : 0.88,
        "&:hover": {
          boxShadow: 3,
        },
      }}
    >
      <CardContent sx={{ pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1}>
          <Typography
            variant="h6"
            fontWeight={600}
            color={isActive ? "primary" : "text.secondary"}
            sx={{ flex: 1, wordBreak: "break-word", lineHeight: 1.3 }}
          >
            {hotel.hotel_name}
          </Typography>
          <Tooltip title={isActive ? "Hotel is active and visible in Inquiry form" : "Hotel is inactive and hidden from Inquiry form"}>
            <Chip
              size="small"
              label={isActive ? "Active" : "Inactive"}
              color={isActive ? "success" : "default"}
              variant={isActive ? "filled" : "outlined"}
              sx={{ fontWeight: 600, fontSize: "0.72rem", height: 22 }}
            />
          </Tooltip>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Typography variant="body2" sx={{ mb: 0.5 }}>
          <b>Location:</b> {hotel.destination} - {hotel.sub_destination}
        </Typography>
        <Typography variant="body2" sx={{ mb: 0.5 }}>
          <b>Type:</b> {hotel.type}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <b>Rating:</b> ⭐ {hotel.rating || 0}
        </Typography>

        {/* Active / Inactive Toggle Switch */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1,
            mt: 1,
            borderRadius: 1.5,
            bgcolor: isActive ? "#f0fdf4" : "#f1f5f9",
            border: `1px solid ${isActive ? "#bbf7d0" : "#e2e8f0"}`,
          }}
        >
          <Typography variant="caption" fontWeight={600} color={isActive ? "success.dark" : "text.secondary"}>
            {isActive ? "Visible in Inquiry" : "Hidden from Inquiry"}
          </Typography>
          <Box display="flex" alignItems="center" gap={0.5}>
            {isLoading ? (
              <CircularProgress size={18} sx={{ mr: 1 }} />
            ) : (
              <Tooltip title={isActive ? "Click to deactivate hotel" : "Click to activate hotel"}>
                <Switch
                  size="small"
                  checked={isActive}
                  onChange={(e) => onToggleActive && onToggleActive(hotel, e)}
                  color="success"
                  disabled={isLoading || (permissions && !permissions.edit)}
                  inputProps={{ "aria-label": "Toggle Hotel Active Status" }}
                />
              </Tooltip>
            )}
          </Box>
        </Box>
      </CardContent>

      <CardActions sx={{ mt: "auto", justifyContent: "space-between", p: 2, pt: 1 }}>
        <Button size="small" variant="outlined" onClick={() => onView(hotel)}>
          View
        </Button>

        {permissions?.edit && (
          <Button size="small" variant="outlined" color="success" onClick={() => onEdit(hotel)}>
            Edit
          </Button>
        )}

        {permissions?.delete && (
          <Button size="small" variant="outlined" color="error" onClick={() => onDelete(hotel._id)}>
            Delete
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default HotelCard;
